import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { replace } from "react-router-redux";
import { reduxForm, formValueSelector } from "redux-form";

import FormPlaylist from "../form/FormPlaylist";

import Loading from "../../utils/loading/Loading";
import Retry from "../../utils/retry/Retry";

import { addPlaylistRequest, addPlaylistDone } from "./actions";
import { getPlaylistsRequest } from "../actions";

class AddPlaylist extends React.Component {
  static propTypes = {
    playlists: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      playlists: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string,
          id: PropTypes.string.isRequired,
        })
      ),
    }).isRequired,
    videos: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      error: PropTypes.String,
      videos: PropTypes.arrayOf(
        PropTypes.shape({
          videoTitle: PropTypes.string.isRequired,
          description: PropTypes.string,
          id: PropTypes.string.isRequired,
          file: PropTypes.string.isRequired,
          duration: PropTypes.number,
        })
      ),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    "add-playlist": PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
    }).isRequired,
    addPlaylistRequest: PropTypes.func.isRequired,
    getPlaylistsRequest: PropTypes.func.isRequired,
    addPlaylistDone: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    playlistModel: PropTypes.string,
  };

  static defaultProps = {
    playlistModel: "Aucun",
  };
  state = {
    isMobile: false,
  };

  componentDidMount() {
    if (typeof this.props.playlists.playlists === "undefined") {
      this.getPlaylists();
    }
    this.setState({ isMobile: window.innerWidth < 1200 });
    window.addEventListener(
      "resize",
      () => {
        this.setState({ isMobile: window.innerWidth < 1200 });
      },
      false
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.playlistModel !== this.props.playlistModel) {
      this.handleModelUpdate(nextProps.playlistModel);
    }
  }

  componentWillUnmount() {
    this.props.addPlaylistDone();
  }

  getPlaylists = () => {
    const { id: accessToken, userId } = this.props.login.authData;
    this.props.getPlaylistsRequest({ accessToken, userId });
  };

  submit = (values) => {
    const { id: accessToken, userId } = this.props.login.authData;
    this.props.addPlaylistRequest({
      values,
      videos: this.props.videos.videos,
      accessToken,
      userId,
    });
  };

  handleModelUpdate = (model) => {
    const {
      playlists: { playlists },
    } = this.props;

    const playlist = playlists.find(({ id }) => id === model);

    if (typeof playlist === "undefined") {
      this.props.initialize({ model: "Aucun" });
    } else {
      const initialValues = {
        model: playlist.id,
        title: playlist.title,
        description: playlist.description,
      };

      this.props.initialize(initialValues);
    }
  };

  handleRetry = () => {
    this.getPlaylists();
  };

  render() {
    const {
      handleSubmit,
      playlistModel,
      playlists: {
        requesting: getPlaylistsRequesting,
        successful: getPlaylistsSuccessful,
        error,
        playlists,
      },
      videos: { requesting: getVideosRequesting, error: getVideosError },
      "add-playlist": {
        requesting: addPlaylistRequesting,
        successful: addPlaylistSuccessful,
      },
    } = this.props;

    return (
      <Fragment>
        {getPlaylistsRequesting && <Loading size={80} />}
        {getPlaylistsSuccessful && (
          <FormPlaylist
            title="Nouvelle playlist"
            playlists={playlists}
            handleOnSubmit={handleSubmit(this.submit)}
            requesting={addPlaylistRequesting}
            successful={addPlaylistSuccessful}
            selectedPlaylistId={playlistModel}
            preventSubmit={getVideosRequesting || getVideosError}
            isMobile={this.state.isMobile}
          />
        )}
        {error && <Retry message={error} onRetry={this.handleRetry} />}
      </Fragment>
    );
  }
}

const selector = formValueSelector("add-playlist");
const mapStateToProps = (state) => ({
  playlists: state.playlists,
  videos: state.videos,
  login: state.login,
  "add-playlist": state["add-playlist"],
  playlistModel: selector(state, "model"),
  initialValues: selector(state, "model")
    ? { model: selector(state, "model") }
    : {
        model: "Aucun",
      },
});

const ConnectedAddPlaylist = connect(mapStateToProps, {
  addPlaylistRequest,
  addPlaylistDone,
  getPlaylistsRequest,
  navigateTo: replace,
})(AddPlaylist);

export default reduxForm({
  form: "add-playlist",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(ConnectedAddPlaylist);



// WEBPACK FOOTER //
// ./src/pages/playlists/add/AddPlaylist.jsx